import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class AuditoriaService {
  constructor(private gqlclient: GraphQLClient) { }
  
  ObtenerAuditoriaCliente(
    inputParams: any, 
    callback: Function
  ){
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaCliente(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      }, function(response: any) {
        const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaCliente;
        callback({ mensajes, respuesta });
      }
    )
  }
  ObtenerAuditoriaProducto(
    inputParams: any, 
    callback: Function
  ){
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      }, function(response: any) {
        const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaProducto;
        callback({ mensajes, respuesta });
      }
    )
  }
  ObtenerAuditoriaDescuentosEspecial(
    inputParams: any, 
    callback: Function
  ){
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaDescuentoEspecial(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                    producto_sku
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      }, function(response: any) {
        const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaDescuentoEspecial;
        callback({ mensajes, respuesta });
      }
    )
  }
  ObtenerAuditoriaDescuentosMaximos(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaDescuentoMaximo(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                    producto_sku
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      }, function(response: any) {
        const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaDescuentoMaximo;
        callback({ mensajes, respuesta });
      }
    )
  }
}